import { PopoverOptionsModel } from '../interfaces/popover-options.model';

export const selectPopoverConfigLang: PopoverOptionsModel = {
    size: 'auto',
};

export const selectPopoverConfig: PopoverOptionsModel = {
    size: 'cover',
    cssClass: 'select-popover-control',
};
